<template id="filteroptions">
    <div class="leftsidebar stickyfooter" v-if="!$parent.$parent.isDesktop">
      <!--Mobile Footer Filter Options-->
        <div class="thm1 filteroption">
            <div
              class="btn col text-uppercase sort"
              :class="isMenWomenFooterBarActive ? 'btn-bottom-up' : ''"
            :style=" bannerPlaceHolderForNewExclusiveRevamp ? 'background : #ed3031;padding-bottom: 3px;padding-top: 5px;font-size: 1rem;' : 'background : #1A1E29'"
            @click="triggerAddMembership">
                {{this.excButtonText ? this.excButtonText : 'JOIN NOW'}}
             </div>
        </div>
        <div class="filteroptionsModal" id="sort">
            <div class="row filterbtns showmobile d-flex justify-content-center">
              <div class="col-md-4 col-sm-4 col-4" v-if="!hideExclusiveCard">
                  <button type="button" class="btn btn-outline-primary btn-block" @click="addMembershipToCartAndClose(EXCLUSIVE_PRODUCTS[0].prod_id)">₹ 99/ Month</button>
              </div>
              <div class="col-md-4 col-sm-4 col-4">
                  <button type="button" class="btn btn-outline-primary btn-block" @click="addMembershipToCartAndClose(EXCLUSIVE_PRODUCTS[1].prod_id)">₹ 149/ 3 Months</button>
              </div>
              <div class="col-md-4 col-sm-4 col-4">
                  <button type="button" class="btn btn-outline-primary btn-block" @click="addMembershipToCartAndClose(EXCLUSIVE_PRODUCTS[2].prod_id)">₹ 199/ Year</button>
              </div>
            </div>
        </div>
    </div>
</template>

<script>

  var $ = require('jquery')
  window.jQuery = $
  import {mapGetters} from 'vuex'
  import Vue from 'vue'
  export default {
    props: ['addMembershipToCart', 'togglePopup', 'excCartDataItem', 'addExclusiveMem', 'excButtonText'],
    data () {
      return {
        hideExclusiveCard: false
      }
    },
    computed: {
      ...mapGetters(['site_config', 'isExclusive', 'bannerPlcaeHolderData', 'isComboActive']),
      EXCLUSIVE_PRODUCTS: function () {
        return this.site_config.exclusive_products
      },
      bannerPlaceHolderForNewExclusiveRevamp: function () {
        const isExclusiveRevampObj = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'EXCLUSIVE_REVAMP_NEW'.toLowerCase())
        if (isExclusiveRevampObj) {
          return true
        }
        return null
      },
      bannerPlaceHolderForMenWomenMsite: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'MENWOMEN_MSITE'.toLowerCase())
      },
      isMenWomenFooterBarActive () {
        if ((this.isComboActive && this.bannerPlaceHolderForMenWomenMsite && !this.$parent.isDesktop) && (this.$route.path === '/men' || this.$route.path === '/kids' || this.$route.path === '/women' || this.$route.path === '/categories' || this.$route.path === '/sneakers' || this.$route.path === '/mywishlist' || this.$route.path === '/profile' || this.$route.path === '/membership')) {
          return true
        } else {
          return false
        }
      }
    },
    watch: {},
    methods: {
      // addToCartMobile: function () {
      //   $('html, body').animate({ scrollTop: $('#buy-exc-membership').offset().top - 90 }, 'fast')
      // },
      triggerAddMembership () {
        if (this.bannerPlaceHolderForNewExclusiveRevamp) {
          if (this.excCartDataItem) {
            this.addExclusiveMem(this.excCartDataItem)
          } else {
            Vue.toasted.show('Please Select Membership Plan', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
            let elem = document.getElementsByClassName('exclusiveTitleNew')
            if (elem && elem.length > 0) {
              elem[0].scrollIntoView({block: 'center', behavior: 'smooth'})
            }
          }
        } else {
          this.addMembershipToCart(this.EXCLUSIVE_PRODUCTS[2].prod_id)
        }
      },
      shouldhideExclusiveCard: function () {
        const currentTime = new Date()
        // console.log('start', new Date() - new Date('2019-12-20 00:00'))
        // console.log('end', new Date() - new Date('2019-12-20 23:59'))
        if (currentTime - new Date('2019-12-20 00:00') > 0 && currentTime - new Date('2019-12-20 23:59') < 0) {
          this.hideExclusiveCard = true
        }
      },
      addMembershipToCartAndClose (item) {
        this.addMembershipToCart(item)
        this.closeFilterModal()
      },
      closeFilterModal () {
        $('.filteroptionsModal').removeClass('active')
        $('.plisting').removeClass('disable')
        $('.filteroption').removeClass('active')
        $('.btn').removeClass('active')
        $('.page-overlay').removeClass('show')
      },
      toggleFilter (opt) {
        // debugger
        if ($('#' + opt).hasClass('active')) {
          $('#' + opt).toggleClass('active')
          $('.' + opt).toggleClass('active')
          $('.filteroption').toggleClass('active')
          $('.plisting').toggleClass('disable')
          $('.page-overlay').toggleClass('show')
        } else {
          $('.filteroptionsModal').removeClass('active')
          $('.btn').removeClass('active')
          $('#' + opt).addClass('active')
          $('.' + opt).addClass('active')
          $('.filteroption').addClass('active')
          $('.plisting').addClass('disable')
          $('.page-overlay').addClass('show')
        }
      }
    },
    mounted: function () {
      this.shouldhideExclusiveCard()
      if ($(window).width() > 768) {
        var fw = $('.leftsidebar').width()
        $('.filtersection').css('width', fw)
        $(window).scroll(function (event) {
          var scrollPosition = window.pageYOffset
          var windowSize = window.innerHeight
          var bodyHeight = document.body.offsetHeight
          var scroll = Math.max(bodyHeight - (scrollPosition + windowSize), 0)
          var fheight = $('footer').height()
          if (scroll > fheight && scrollPosition > fheight) {
            $('.leftsidebar').addClass('stickyfilter')
          } else if ($(window).scrollTop() + screen.height > $('body').height()) {
            $('.leftsidebar').removeClass('stickyfilter')
          } else {
            $('.leftsidebar').removeClass('stickyfilter')
          }
        })
      } else {
        $('.page-overlay').on('click', this.closeFilterModal)
      }
      if (!this.$parent.isDesktop) {
        this.$store.commit('SET_FOOTER_COLLAPSE_CONTROL', {
          expanded: true,
          expandedClass: 'show', // '' or show
          bottomStyle: 'margin-bottom: 45px;'
        })
      }
    }
  }

</script>

<style lang="css" scoped>
  .dselect {
    width: 115px;
  }

  .stickyfooter .thm1 {
    background: #ed2d2f;
    color: #fff
  }
  .stickyfilter {
    position: fixed;
    top: 85px;
    background: #fff;
  }

  .childAccordian .card {
    border-bottom: 0;
  }

  .childAccordian .card a {
    border-bottom: 0;
    padding: 10px 0;
    text-transform: inherit;
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 400;
    color: #000 !important;
  }

  .custaccordian .card-header a[aria-expanded="false"]:before, .custaccordian .mbFaqheader a[aria-expanded="false"]:before,
  .custaccordian .card-header a[aria-expanded="true"]:before, .custaccordian .mbFaqheader a[aria-expanded="true"]:before {
    top: 5px;
  }

  .custaccordian .childAccordian .card-header a[aria-expanded="true"]:before,
  .custaccordian .childAccordian .card-header a[aria-expanded="false"]:before {
    top: 4px;
  }

  .customcheckbox [type="checkbox"]:not(:checked) + label:before, .customcheckbox [type="checkbox"]:checked + label:before {
    top: 0;
  }

  .customcheckbox, .customradio {
    line-height: 18px;
  }
  .customcheckbox [type="checkbox"] + label:before {
    top: 0 !important;
  }

  .filtersection {
    overflow-y: scroll;
    max-height: 70vh;
  }

  @media screen and (max-width: 991px) {
    .childAccordian {
      padding: 0 10px;
    }
    .btn-bottom-up {
      bottom: 62px;
    }
    .filteroptionsModal {
      min-height: 80px;
    }
    .filterbtns {
      padding-right: 5px;
    }
    .stickyfooter {
      z-index: 99;
    }
    .filteroption {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
    .filteroptionsModal {
      overflow-y: scroll;
      max-height: 70px;
      border: none;
    }
    .customcheckbox [type="checkbox"]:checked + label:after, .customradio [type="radio"]:checked + label:after {
      top: 3px;
      left: 2px;
    }
    .filteroption {
      border: none;
    }
  }

  .filter-search {
    border-radius: 5px;
    margin-bottom: 15px;
  }

  .maxer {
    max-height: 33vh;
    min-height: 5vh;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// exclusiveAddToCart.vue?36e4d591